import { render, staticRenderFns } from "./framework-snackbar-stack.vue?vue&type=template&id=573c6be3&"
import script from "./framework-snackbar-stack.vue?vue&type=script&lang=js&"
export * from "./framework-snackbar-stack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports